import { render, staticRenderFns } from "./slgroup-stats.vue?vue&type=template&id=1a56617a&scoped=true"
import script from "./slgroup-stats.vue?vue&type=script&lang=js"
export * from "./slgroup-stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56617a",
  null
  
)

export default component.exports